export default __webpack_public_path__ + "static/media/stp_icon.913df854.svg";